<script lang="ts">
    import Fa from 'svelte-fa'
    import Zframe from '../_common/z/zframe.svelte'
    import { faSave, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte'
    import type { Invoice } from '../../modules/posApi/invoices/invoice'
    import type { Entry } from '../../modules/financialApi/entries/entry'
    import { PaymentMethodTypeEnum, type PaymentMethod } from '../../modules/posApi/payment-methods/payment-methods'
    import { EntryTypeEnum } from '../../modules/financialApi/entries/entry.enum'
    import Zinput from '../_common/z/zinput.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import type { CashierEntity } from '../../modules/posApi/cashiers/cashier.entity'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import ZinputTitle from '../_common/z/zinput-title.svelte'
    const dispatch = createEventDispatcher()

    export let cashierId: string

    let cashResult: number = 0
    let cashIn: number = 0
    let cashOut: number = 0
    let cashClose: number = 0

    interface iResult {
        id: string
        label: string
        detected: number
        informed: number
        type: string
    }

    let results: iResult[] = []

    let cashier: CashierEntity = null
    let paymentMethods: PaymentMethod[] = []
    async function loadDetecteds() {
        cashier = await window.api.pos.cashiers.getOne(cashierId)
        paymentMethods = await window.api.pos.paymentMethods.getAll()
        const invoices: Invoice[] = await window.api.pos.invoices.getAll({ cashierId })
        const inOuts: Entry[] = await window.api.financials.entries.getAll({ cashierId })
        results = cashier.result || []
        // reseta o detected para ser recalculado
        for (const result of results) {
            result.detected = 0
        }
        cashIn = 0
        cashOut = 0
        for (const invoice of invoices) {
            for (const payment of invoice.payments) {
                let result = results.find((el) => el.id === payment.paymentMethodId)
                if (!result) {
                    const pm = paymentMethods.find((el) => el.paymentMethodId === payment.paymentMethodId)
                    result = { detected: 0, informed: 0, label: pm?.label, id: pm.paymentMethodId, type: pm.type }
                    results.push(result)
                }
                result.detected += payment.value
                cashIn += payment.value
            }
        }
        let ins: iResult = results.find((el) => el.id === 'in')
        if (!ins) {
            ins = { detected: 0, informed: 0, label: 'Entradas', id: 'in', type: 'money' }
            results.push(ins)
        }
        let outs: iResult = results.find((el) => el.id === 'out')
        if (!outs) {
            outs = { detected: 0, informed: 0, label: 'Saídas', id: 'out', type: 'money' }
            results.push(outs)
        }
        for (const inOut of inOuts) {
            if (inOut.type === EntryTypeEnum.credit) {
                ins.detected += inOut.value
                cashIn += inOut.value
            } else {
                outs.detected += inOut.value
                cashOut += inOut.value
            }
        }
    }

    async function saveEntity() {
        try {
            if (!cashier.cashClose) {
                if (!confirm('Você não informou um troco para o dia seguinte.\nDeseja continuar?')) return
            }
            for (const result of results) {
                if (Math.round(result.detected) != Math.round(result.informed)) {
                    if (!confirm('O caixa possui divergências.\nDeseja fechar mesmo assim?')) return
                    break
                }
            }
            const result = await window.api.pos.cashiers.close(cashierId, cashier.cashClose, null, null, null, results)
            dispatch('close')
        } catch (error) {
            window.error(error)
        }
    }

    $: {
        calculateResult(results)
    }

    let message = ''
    function calculateResult(_results: iResult[]) {
        const divergence = _results.reduce((acc, el) => {
            if (el.id == 'out') {
                acc += el.informed - el.detected
            } else {
                acc += el.detected - el.informed
            }

            return acc
        }, 0)
        cashResult = _results.reduce((acc, el) => {
            if (el.id == 'out') {
                acc -= el.informed
            } else {
                acc += el.informed
            }
            return acc
        }, 0)
        message = ''
        if ((divergence > 0.01 || divergence < -0.01) && cashClose + cashResult !== 0) {
            message = 'Seu caixa possui divergências'
        }
    }

    onMount(async () => {
        await loadDetecteds()
    })

    function getHelp(id: string) {
        if (id === 'in') return 'Entradas no caixa do PDV via "Entradas e Saídas" (ex.: reforço de troco)'
        if (id === 'out') return 'Saídas no caixa do PDV via "Entradas e Saídas"  (ex.: sangria)'
        if (id.length < 36) return ''
        const type = paymentMethods.find((el) => el.paymentMethodId === id)?.type
        if (type === PaymentMethodTypeEnum.money)
            return 'Informe apenas o valor em dinheiro recebido da venda de produtos e serviços.\nNão inclua o troco inicial e não desconte o troco para o dia seguinte.'
        return 'Informe o valor total recebido por este meio de pagamento somando os recibos.'
    }

    let toggleByType: any = window.configs.posCashierShowClosingTotals ? 'number' : 'password'
    function toggleCalculated() {
        toggleByType = toggleByType === 'number' ? 'password' : 'number'
        console.log('ok', toggleByType)
    }
</script>

<div class="grid-act">
    <div class="spacer" />
    {#if window.store.token.permissions.pos.sales.write && cashier?.status <= 100}
        <button class="btn btn-primary" on:click={saveEntity}><Fa icon={faSave} /> Salvar</button>
    {/if}
</div>

{#if cashier}
    <Zframe class="m-3" title="Fechamento de Caixa">
        <ZContainer>
            <Zinput type="number" disabled={true} size={6} label="Dinheiro - Troco inicial" value={cashier.cashOpen}></Zinput>
            <Zinput type="number" disabled={cashier.status > 100} size={6} label="Dinheiro - Troco para o dia seguinte" bind:value={cashier.cashClose}></Zinput>
            <ZContainerCol size={6}>
                <div class="cashier-eye">
                    <div>Dinheiro movimentado</div>
                    {#if !window.configs.posCashierShowClosingTotals && window.store.token.permissions.super}
                        <div on:click={toggleCalculated} title="Este botão é visível apenas para super usuários">
                            <Fa icon={toggleByType === 'number' ? faEye : faEyeSlash}></Fa>
                        </div>
                    {/if}
                </div>
            </ZContainerCol>
            <ZContainerCol size={6}>Dinheiro encontrado</ZContainerCol>
            {#each results as result}
                {#if result.type === 'money'}
                    <Zinput type={toggleByType} disabled={true} size={6} label={result.label} value={result.detected}></Zinput>
                    <Zinput type="number" disabled={cashier.status > 100} size={6} label={result.label} help={getHelp(result.id)} bind:value={result.informed}
                    ></Zinput>
                {/if}
            {/each}
            <ZContainerCol size={6}>
                <div class="cashier-eye">
                    <div>Comprovantes necessários</div>
                    {#if !window.configs.posCashierShowClosingTotals && window.store.token.permissions.super}
                        <div on:click={toggleCalculated} title="Este botão é visível apenas para super usuários">
                            <Fa icon={toggleByType === 'number' ? faEye : faEyeSlash}></Fa>
                        </div>
                    {/if}
                </div>
            </ZContainerCol>
            <ZContainerCol size={6}>Comprovantes encontrados</ZContainerCol>
            {#each results as result}
                {#if result.type !== 'money'}
                    <Zinput type={toggleByType} disabled={true} size={6} label={result.label} value={result.detected}></Zinput>
                    <Zinput type="number" disabled={cashier.status > 100} size={6} label={result.label} help={getHelp(result.id)} bind:value={result.informed}
                    ></Zinput>
                {/if}
            {/each}
        </ZContainer>
        <div>
            {#if message}
                <div class="row mt-2">
                    <div class="col">
                        <div class="alert alert-warning text-center">{message}</div>
                    </div>
                </div>
            {/if}
        </div>
    </Zframe>
{/if}

<style>
    .cashier-eye {
        display: flex;
        align-items: center;
    }
    .cashier-eye > div {
        padding-right: 8px;
    }
</style>
